import _ from "lodash";

export const translate = (languageOrCode) => {
    if (_.isNull(languageOrCode)) {
        return null;
    }

    const englishPossibilities = ["en", "en-us", "english"];
    const portuguesePossibilities = ["pt", "pt-br", "portuguese", "pt-pt", "portugal"];
    const spanishPossibilities = ["es", "es-es", "spanish"];

	if (englishPossibilities.includes(languageOrCode.toLowerCase())) {
        return "Inglês";
    }

	if (spanishPossibilities.includes(languageOrCode.toLowerCase())) {
        return "Espanhol";
    }

	if (portuguesePossibilities.includes(languageOrCode.toLowerCase())) {
        return "Português";
    }
};

export default {
	translate,
};